import React from 'react';
import { PartnerRecommendation as PartnerRecommendationType } from '../../types/launchpad';

interface PartnerRecommendationProps {
  partner: PartnerRecommendationType;
  userRegion?: string; // User's region (e.g., 'US', 'UK')
}

const PartnerRecommendation: React.FC<PartnerRecommendationProps> = ({ partner, userRegion = 'US' }) => {
  // Check if partner is available in user's region
  const isAvailableInRegion = !partner.regions || partner.regions.includes(userRegion) || partner.regions.includes('Global');
  
  if (!isAvailableInRegion) return null;
  
  return (
    <div className="border border-blue-100 rounded-md p-3 bg-blue-50 mb-2">
      <div className="flex justify-between items-start">
        <div>
          <h4 className="font-medium text-blue-800">{partner.name}</h4>
          <p className="text-sm text-gray-600 mt-1">{partner.description}</p>
        </div>
        {partner.logo_url && (
          <img 
            src={partner.logo_url} 
            alt={`${partner.name} logo`} 
            className="w-10 h-10 object-contain"
          />
        )}
      </div>
      
      {partner.commission_info && (
        <div className="mt-2 text-xs text-green-600 font-medium">
          <span className="bg-green-100 px-2 py-1 rounded-full">
            {partner.commission_info}
          </span>
        </div>
      )}
      
      <div className="mt-3">
        <a 
          href={partner.referral_url || partner.website_url} 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-sm bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded-md inline-flex items-center transition-colors"
        >
          Learn More
          <svg className="w-3.5 h-3.5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default PartnerRecommendation;
